define((require) => {
    'use strict';

    require('../__legal-suggestion/billing-registration__legal-suggestion');
    require('../__empty-suggest/billing-registration__empty-suggest');

    const FormLayer = require('system/blocks/form-layer/form-layer');
    const Suggest = require('system/blocks/suggest/suggest');

    return FormLayer.extend('billing-registration__stage-initial', {
        inner: true,
        renderMode: 'replace',
        service: false,

        title: 'Дорегистрация',

        _onLegalInfoSelected(event, value) {
            this.emit('legalInfoSelected', value);
        },

        onClose() {
            this.emit('cancel');
        },

        putSuggestData(data) {
            this._suggest.updateSuggestions(data);
        },

        width: 420,

        mods: [
            'centered-header',
            'billing-registration',
            'billing-registration__stage-initial',
        ],

        fields(data) {
            const defs = this.defs;

            return [
                {
                    columns: [
                        {
                            block: 'b-input',
                            label: 'ИНН',
                            mods: ['responsive', 'icon-search'],
                            errors: [
                                {
                                    type: 'invalid',
                                    text: 'Неверный ИНН',
                                },
                                {
                                    type: 'pattern',
                                    text:
                                        'ИНН должен состоять из 10 или 12 цифр',
                                },
                                {
                                    type: 'required',
                                    text: 'Заполните ИНН',
                                },
                            ],
                            props: {
                                placeholder:
                                    'Введите свой ИНН (10 или 12 цифр)',
                                type: 'text',
                                name: defs.INN,
                                value: data[defs.INN],
                                required: true,
                                pattern: '^(\\d{10}|\\d{12})$',
                                maxlength: 12,
                                autofocus: 'autofocus',
                                tabindex: 1,
                            },
                        },
                    ],
                },
            ];
        },

        _validateInnField() {
            const innInput = this._form.getField(this.defs.INN);
            const inputValue = innInput.getValue();

            clearTimeout(this._validationTimeout);

            if (this.destroyed) {
                return;
            }

            if (inputValue.length) {
                this._validationTimeout = setTimeout(() => {
                    if (!innInput.error) {
                        this._form.validate();
                    }
                }, 1000);
            }
        },

        onRender() {
            FormLayer.fn.onRender.call(this);

            const innInput = this._form.getField(this.defs.INN);
            innInput.input.el.setSelectionRange(
                this.innInputState.start,
                this.innInputState.end,
            );

            this._validateInnField();
            innInput.on('changeFormValue', this._validateInnField.bind(this));

            this._validationTimeout = null;

            this._suggest = new Suggest({
                inputLength: [10, 12],
                el: document.createElement('div'),
                itemBlock: 'billing-registration__legal-suggestion',
                emptySuggestBlock: 'billing-registration__empty-suggest',
                inputElement: innInput.input.$el,
                source: this.putSuggestData.bind(this),
                onSelect: this._onLegalInfoSelected.bind(this),
            });

            this._suggest.render();
        },

        destroy() {
            clearTimeout(this._validationTimeout);
            this._suggest.destroy();
        },
    });
});
